if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.currentVariant = this.form.querySelector('.product-variant-id');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (!this.currentVariant.value) {
          const select = document.querySelector(`#variant-selects-${this.form.dataset.id} .select-product-wrap`);
          select.classList.add('has-error');
          return;
        }

        const product = JSON.parse(this.querySelector('.json').textContent);
        const productId = parseInt(this.dataset.id, 10) || product.id;
        // Per-order purchase limit from the product tags (limit1 / limit:N), rendered by Liquid as data-limit.
        const limit = parseInt(this.dataset.limit, 10) || parsePurchaseLimit(product.tags);
        const soldOutMessage = document.querySelector(`.sold-out-message-${this.form.dataset.id}`);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const cart = readCartData();
        const requested = parseInt(formData.get('quantity'), 10) || 1;

        if (limit > 0 && productQuantityInCart(cart, productId) + requested > limit) {
          // Client-side guard only; the checkout validation function enforces the same rule server-side.
          const message = purchaseLimitMessage(limit);
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: 'purchase-limit',
            message,
          });
          soldOutMessage.classList.remove('hidden');
          soldOutMessage.textContent = message;
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('is-loading');

        if (limit === 0) {
          // Untagged products keep the legacy client-side cap of 5 per variant.
          const variantInCart = cart.items.find((l) => l.variant_id === parseInt(this.currentVariant.value));
          if (!!variantInCart && variantInCart.quantity >= 5) {
            const body = JSON.stringify({
              id: `${variantInCart.id}`,
              quantity: '4',
            });
            await fetch('/cart/change.js', { ...fetchConfig(), ...{ body } })
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                // console.log("update success", state);
              })
              .catch((error) => console.error('/cart/change.js', error));
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              soldOutMessage.classList.remove('hidden');
              soldOutMessage.textContent = response.description;
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            } else {
              soldOutMessage.classList.add('hidden');
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('is-loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
